export default __webpack_public_path__ + "static/media/badge2.00b44046.svg";